// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Вкладка «Удалить пользователя» (DEV) */
.adu-page {
  --adu-danger: #dc2626;
  --adu-danger-strong: #b91c1c;
  --adu-danger-soft: rgba(220, 38, 38, 0.08);
  --adu-danger-border: rgba(220, 38, 38, 0.22);
  --adu-surface: rgba(255, 255, 255, 0.72);
  --adu-surface-solid: #ffffff;
  --adu-line: rgba(148, 163, 184, 0.2);
  --adu-muted: #64748b;
  width: 100%;
}

[data-theme='dark'] .adu-page,
[data-theme='dark'] .adu-modal-backdrop {
  --adu-danger: #f87171;
  --adu-danger-strong: #ef4444;
  --adu-danger-soft: rgba(248, 113, 113, 0.1);
  --adu-danger-border: rgba(248, 113, 113, 0.28);
  --adu-surface: var(--bg-secondary);
  --adu-surface-solid: #1e293b;
  --adu-line: rgba(148, 163, 184, 0.16);
  --adu-muted: #8b98ae;
}

.adu-modal-backdrop {
  --adu-danger: #dc2626;
  --adu-danger-strong: #b91c1c;
  --adu-danger-soft: rgba(220, 38, 38, 0.08);
  --adu-danger-border: rgba(220, 38, 38, 0.22);
  --adu-surface-solid: #ffffff;
  --adu-line: rgba(148, 163, 184, 0.2);
  --adu-muted: #64748b;
}

.adu-shell {
  max-width: 920px;
  margin: 0 auto;
  background: var(--adu-surface);
  border: 1px solid var(--adu-line);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

[data-theme='dark'] .adu-shell {
  border-color: var(--border-color);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

/* ── Шапка ── */
.adu-hero {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 26px 28px 20px;
  background:
    radial-gradient(120% 140% at 0% 0%, rgba(220, 38, 38, 0.08) 0%, transparent 55%),
    transparent;
}

.adu-hero-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  color: #fff;
  background: linear-gradient(145deg, #f87171 0%, #dc2626 100%);
  box-shadow: 0 8px 20px rgba(220, 38, 38, 0.3);
}

.adu-hero-texts {
  min-width: 0;
}

.adu-hero-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0;
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--text-primary);
}

.adu-hero-subtitle {
  margin: 4px 0 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.adu-dev-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  color: #7c3aed;
  background: rgba(124, 58, 237, 0.1);
  border: 1px solid rgba(124, 58, 237, 0.2);
}

[data-theme='dark'] .adu-dev-chip {
  color: #c4b5fd;
  background: rgba(167, 139, 250, 0.14);
  border-color: rgba(167, 139, 250, 0.28);
}

.adu-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 28px;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 0.86rem;
  line-height: 1.45;
  color: var(--adu-danger-strong);
  background: var(--adu-danger-soft);
  border: 1px solid var(--adu-danger-border);
}

[data-theme='dark'] .adu-warning {
  color: #fca5a5;
}

.adu-warning svg {
  flex-shrink: 0;
  margin-top: 1px;
}

/* ── Поиск ── */
.adu-search {
  padding: 20px 28px 18px;
  border-bottom: 1px solid var(--adu-line);
}

.adu-search-field {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 52px;
  padding: 0 14px 0 16px;
  border-radius: 14px;
  background: var(--adu-surface-solid);
  border: 1.5px solid var(--border-color);
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.adu-search-field:focus-within {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 4px var(--border-focus);
}

.adu-search-icon {
  flex-shrink: 0;
  color: var(--adu-muted);
}

.adu-search-input {
  flex: 1 1;
  min-width: 0;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 1rem;
  color: var(--text-primary);
}

.adu-search-input::placeholder {
  color: var(--adu-muted);
}

.adu-search-input::-webkit-search-cancel-button {
  display: none;
}

.adu-search-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: var(--adu-muted);
  background: transparent;
  transition: background 0.15s ease, color 0.15s ease;
}

.adu-search-clear:hover {
  color: var(--text-primary);
  background: rgba(148, 163, 184, 0.16);
}

.adu-search-hints {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.adu-search-hints span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 0.75rem;
  color: var(--adu-muted);
  background: rgba(148, 163, 184, 0.1);
}

/* ── Результаты ── */
.adu-body {
  padding: 18px 28px 26px;
  min-height: 220px;
}

.adu-toast {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 16px 28px 0;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #047857;
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.25);
}

[data-theme='dark'] .adu-toast {
  color: #6ee7b7;
}

.adu-results-head {
  margin-bottom: 10px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--adu-muted);
}

.adu-results {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.adu-user {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 14px;
  background: var(--adu-surface-solid);
  border: 1px solid var(--adu-line);
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.adu-user:hover {
  border-color: var(--adu-danger-border);
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.06);
}

[data-theme='dark'] .adu-user {
  background: var(--bg-tertiary);
}

.adu-avatar {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(145deg, #60a5fa 0%, #6366f1 100%);
}

.adu-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.adu-user-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.adu-user-name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.adu-user-name {
  font-size: 0.98rem;
  font-weight: 700;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.adu-role,
.adu-status {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  color: #475569;
  background: rgba(148, 163, 184, 0.16);
}

.adu-role--customer { color: #2563eb; background: rgba(37, 99, 235, 0.1); }
.adu-role--provider { color: #059669; background: rgba(5, 150, 105, 0.1); }
.adu-role--support,
.adu-role--moderator { color: #d97706; background: rgba(217, 119, 6, 0.1); }
.adu-role--admin,
.adu-role--dev { color: #7c3aed; background: rgba(124, 58, 237, 0.1); }

.adu-status {
  color: var(--adu-danger);
  background: var(--adu-danger-soft);
}

[data-theme='dark'] .adu-role { color: #cbd5e1; }
[data-theme='dark'] .adu-role--customer { color: #93c5fd; background: rgba(59, 130, 246, 0.16); }
[data-theme='dark'] .adu-role--provider { color: #6ee7b7; background: rgba(16, 185, 129, 0.16); }
[data-theme='dark'] .adu-role--support,
[data-theme='dark'] .adu-role--moderator { color: #fcd34d; background: rgba(251, 191, 36, 0.14); }
[data-theme='dark'] .adu-role--admin,
[data-theme='dark'] .adu-role--dev { color: #c4b5fd; background: rgba(167, 139, 250, 0.16); }

.adu-user-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  font-size: 0.84rem;
  color: var(--text-secondary);
}

.adu-user-meta span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.adu-user-email {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.adu-user-id {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.adu-user-id code {
  font-family: var(--font-data);
  font-size: 0.74rem;
  color: var(--adu-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.adu-results-more {
  margin: 14px 0 0;
  text-align: center;
  font-size: 0.82rem;
  color: var(--adu-muted);
}

.adu-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 16px;
  text-align: center;
}

.adu-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 14px;
  border-radius: 20px;
  color: var(--adu-muted);
  background: rgba(148, 163, 184, 0.12);
}

.adu-empty-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.adu-empty-text {
  margin: 6px 0 0;
  max-width: 380px;
  font-size: 0.88rem;
  color: var(--text-secondary);
}

/* ── Кнопки ── */
.adu-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 10px 18px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease, transform 0.18s ease, opacity 0.18s ease;
}

.adu-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.adu-btn:focus-visible {
  outline: 2px solid var(--adu-danger);
  outline-offset: 2px;
}

.adu-btn--danger-soft {
  color: var(--adu-danger);
  background: var(--adu-danger-soft);
  border-color: var(--adu-danger-border);
}

.adu-btn--danger-soft:hover:not(:disabled) {
  color: #fff;
  background: var(--adu-danger-strong);
  border-color: var(--adu-danger-strong);
  box-shadow: 0 6px 16px rgba(220, 38, 38, 0.28);
}

.adu-btn--danger {
  color: #fff;
  background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);
  box-shadow: 0 4px 14px rgba(220, 38, 38, 0.32);
}

.adu-btn--danger:hover:not(:disabled) {
  background: linear-gradient(180deg, #dc2626 0%, #b91c1c 100%);
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(220, 38, 38, 0.38);
}

.adu-btn--ghost {
  color: var(--text-primary);
  background: var(--bg-secondary, #f1f5f9);
  border-color: var(--border-color);
}

.adu-btn--ghost:hover:not(:disabled) {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.adu-btn--ghost:focus-visible {
  outline-color: var(--accent-primary);
}

.adu-spinner {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  animation: adu-spin 0.7s linear infinite;
}

.adu-spinner--accent {
  flex-shrink: 0;
  border-color: rgba(148, 163, 184, 0.35);
  border-top-color: var(--accent-primary);
}

@keyframes adu-spin {
  to { transform: rotate(360deg); }
}

/* ── Модалка подтверждения ── */
.adu-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.adu-modal {
  width: min(460px, 100%);
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  padding: 28px 26px 22px;
  border-radius: 20px;
  text-align: center;
  background: var(--adu-surface-solid);
  border: 1px solid var(--adu-line);
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.3);
}

[data-theme='dark'] .adu-modal {
  border-color: var(--border-color);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);
}

.adu-modal-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin-bottom: 14px;
  border-radius: 50%;
  color: var(--adu-danger);
  background: var(--adu-danger-soft);
  box-shadow: 0 0 0 8px rgba(220, 38, 38, 0.05);
}

.adu-modal-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 800;
  color: var(--text-primary);
}

.adu-modal-text {
  margin: 8px 0 18px;
  font-size: 0.9rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

.adu-modal-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 14px;
  text-align: left;
  background: var(--bg-primary);
  border: 1px solid var(--adu-line);
}

.adu-modal-user-texts {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.adu-modal-user-name {
  font-weight: 700;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.adu-modal-user-meta {
  font-size: 0.82rem;
  color: var(--text-secondary);
}

.adu-modal-user-id {
  font-family: var(--font-data);
  font-size: 0.72rem;
  color: var(--adu-muted);
  word-break: break-all;
}

.adu-modal-consequences {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 16px 0;
  padding: 0;
  list-style: none;
  text-align: left;
}

.adu-modal-consequences li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.86rem;
  color: var(--text-secondary);
}

.adu-modal-consequences svg {
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--adu-danger);
}

.adu-ack {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  text-align: left;
  font-size: 0.86rem;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  border: 1.5px dashed var(--adu-danger-border);
  transition: background 0.18s ease, border-color 0.18s ease;
}

.adu-ack.is-checked {
  border-style: solid;
  border-color: var(--adu-danger);
  background: var(--adu-danger-soft);
}

.adu-ack input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.adu-ack-box {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  color: transparent;
  border: 1.5px solid var(--border-color);
  background: var(--adu-surface-solid);
  transition: all 0.15s ease;
}

.adu-ack.is-checked .adu-ack-box {
  color: #fff;
  border-color: var(--adu-danger);
  background: var(--adu-danger);
}

.adu-ack input:focus-visible + .adu-ack-box {
  outline: 2px solid var(--adu-danger);
  outline-offset: 2px;
}

.adu-modal-error {
  margin-top: 12px;
  text-align: left;
}

.adu-modal-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 20px;
}

/* ── Адаптив ── */
@media (max-width: 640px) {
  .adu-hero {
    padding: 20px 18px 16px;
  }

  .adu-warning {
    margin: 0 18px;
  }

  .adu-toast {
    margin: 14px 18px 0;
  }

  .adu-search,
  .adu-body {
    padding-left: 18px;
    padding-right: 18px;
  }

  .adu-user {
    flex-wrap: wrap;
  }

  .adu-user .adu-btn {
    width: 100%;
  }

  .adu-modal {
    padding: 22px 18px 18px;
  }

  .adu-modal-actions {
    grid-template-columns: 1fr;
  }

  .adu-modal-actions .adu-btn--danger {
    order: -1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/admin-delete-user.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,0CAA0C;EAC1C,4CAA4C;EAC5C,wCAAwC;EACxC,4BAA4B;EAC5B,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,4BAA4B;EAC5B,2CAA2C;EAC3C,8CAA8C;EAC9C,kCAAkC;EAClC,4BAA4B;EAC5B,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,0CAA0C;EAC1C,4CAA4C;EAC5C,4BAA4B;EAC5B,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,iCAAiC;EACjC,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB;;eAEa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA,sBAAsB,cAAc,EAAE,kCAAkC,EAAE;AAC1E,sBAAsB,cAAc,EAAE,kCAAkC,EAAE;AAC1E;uBACuB,cAAc,EAAE,kCAAkC,EAAE;AAC3E;iBACiB,cAAc,EAAE,mCAAmC,EAAE;;AAEtE;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA,gCAAgC,cAAc,EAAE;AAChD,0CAA0C,cAAc,EAAE,oCAAoC,EAAE;AAChG,0CAA0C,cAAc,EAAE,oCAAoC,EAAE;AAChG;2CAC2C,cAAc,EAAE,oCAAoC,EAAE;AACjG;qCACqC,cAAc,EAAE,qCAAqC,EAAE;;AAE5F;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B;mEACiE;AACnE;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,6CAA6C;EAC7C,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":["/* Вкладка «Удалить пользователя» (DEV) */\n.adu-page {\n  --adu-danger: #dc2626;\n  --adu-danger-strong: #b91c1c;\n  --adu-danger-soft: rgba(220, 38, 38, 0.08);\n  --adu-danger-border: rgba(220, 38, 38, 0.22);\n  --adu-surface: rgba(255, 255, 255, 0.72);\n  --adu-surface-solid: #ffffff;\n  --adu-line: rgba(148, 163, 184, 0.2);\n  --adu-muted: #64748b;\n  width: 100%;\n}\n\n[data-theme='dark'] .adu-page,\n[data-theme='dark'] .adu-modal-backdrop {\n  --adu-danger: #f87171;\n  --adu-danger-strong: #ef4444;\n  --adu-danger-soft: rgba(248, 113, 113, 0.1);\n  --adu-danger-border: rgba(248, 113, 113, 0.28);\n  --adu-surface: var(--bg-secondary);\n  --adu-surface-solid: #1e293b;\n  --adu-line: rgba(148, 163, 184, 0.16);\n  --adu-muted: #8b98ae;\n}\n\n.adu-modal-backdrop {\n  --adu-danger: #dc2626;\n  --adu-danger-strong: #b91c1c;\n  --adu-danger-soft: rgba(220, 38, 38, 0.08);\n  --adu-danger-border: rgba(220, 38, 38, 0.22);\n  --adu-surface-solid: #ffffff;\n  --adu-line: rgba(148, 163, 184, 0.2);\n  --adu-muted: #64748b;\n}\n\n.adu-shell {\n  max-width: 920px;\n  margin: 0 auto;\n  background: var(--adu-surface);\n  border: 1px solid var(--adu-line);\n  border-radius: 20px;\n  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n}\n\n[data-theme='dark'] .adu-shell {\n  border-color: var(--border-color);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n/* ── Шапка ── */\n.adu-hero {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 26px 28px 20px;\n  background:\n    radial-gradient(120% 140% at 0% 0%, rgba(220, 38, 38, 0.08) 0%, transparent 55%),\n    transparent;\n}\n\n.adu-hero-icon {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  color: #fff;\n  background: linear-gradient(145deg, #f87171 0%, #dc2626 100%);\n  box-shadow: 0 8px 20px rgba(220, 38, 38, 0.3);\n}\n\n.adu-hero-texts {\n  min-width: 0;\n}\n\n.adu-hero-title {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 0;\n  font-size: 1.3rem;\n  font-weight: 800;\n  color: var(--text-primary);\n}\n\n.adu-hero-subtitle {\n  margin: 4px 0 0;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.adu-dev-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  color: #7c3aed;\n  background: rgba(124, 58, 237, 0.1);\n  border: 1px solid rgba(124, 58, 237, 0.2);\n}\n\n[data-theme='dark'] .adu-dev-chip {\n  color: #c4b5fd;\n  background: rgba(167, 139, 250, 0.14);\n  border-color: rgba(167, 139, 250, 0.28);\n}\n\n.adu-warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 0 28px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  font-size: 0.86rem;\n  line-height: 1.45;\n  color: var(--adu-danger-strong);\n  background: var(--adu-danger-soft);\n  border: 1px solid var(--adu-danger-border);\n}\n\n[data-theme='dark'] .adu-warning {\n  color: #fca5a5;\n}\n\n.adu-warning svg {\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n/* ── Поиск ── */\n.adu-search {\n  padding: 20px 28px 18px;\n  border-bottom: 1px solid var(--adu-line);\n}\n\n.adu-search-field {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 52px;\n  padding: 0 14px 0 16px;\n  border-radius: 14px;\n  background: var(--adu-surface-solid);\n  border: 1.5px solid var(--border-color);\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.adu-search-field:focus-within {\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 4px var(--border-focus);\n}\n\n.adu-search-icon {\n  flex-shrink: 0;\n  color: var(--adu-muted);\n}\n\n.adu-search-input {\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 1rem;\n  color: var(--text-primary);\n}\n\n.adu-search-input::placeholder {\n  color: var(--adu-muted);\n}\n\n.adu-search-input::-webkit-search-cancel-button {\n  display: none;\n}\n\n.adu-search-clear {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  color: var(--adu-muted);\n  background: transparent;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.adu-search-clear:hover {\n  color: var(--text-primary);\n  background: rgba(148, 163, 184, 0.16);\n}\n\n.adu-search-hints {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.adu-search-hints span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  color: var(--adu-muted);\n  background: rgba(148, 163, 184, 0.1);\n}\n\n/* ── Результаты ── */\n.adu-body {\n  padding: 18px 28px 26px;\n  min-height: 220px;\n}\n\n.adu-toast {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 16px 28px 0;\n  padding: 12px 14px;\n  border-radius: 12px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #047857;\n  background: rgba(16, 185, 129, 0.1);\n  border: 1px solid rgba(16, 185, 129, 0.25);\n}\n\n[data-theme='dark'] .adu-toast {\n  color: #6ee7b7;\n}\n\n.adu-results-head {\n  margin-bottom: 10px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--adu-muted);\n}\n\n.adu-results {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.adu-user {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  border-radius: 14px;\n  background: var(--adu-surface-solid);\n  border: 1px solid var(--adu-line);\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.adu-user:hover {\n  border-color: var(--adu-danger-border);\n  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.06);\n}\n\n[data-theme='dark'] .adu-user {\n  background: var(--bg-tertiary);\n}\n\n.adu-avatar {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 50%;\n  font-weight: 700;\n  color: #fff;\n  background: linear-gradient(145deg, #60a5fa 0%, #6366f1 100%);\n}\n\n.adu-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.adu-user-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.adu-user-name-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.adu-user-name {\n  font-size: 0.98rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.adu-role,\n.adu-status {\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: #475569;\n  background: rgba(148, 163, 184, 0.16);\n}\n\n.adu-role--customer { color: #2563eb; background: rgba(37, 99, 235, 0.1); }\n.adu-role--provider { color: #059669; background: rgba(5, 150, 105, 0.1); }\n.adu-role--support,\n.adu-role--moderator { color: #d97706; background: rgba(217, 119, 6, 0.1); }\n.adu-role--admin,\n.adu-role--dev { color: #7c3aed; background: rgba(124, 58, 237, 0.1); }\n\n.adu-status {\n  color: var(--adu-danger);\n  background: var(--adu-danger-soft);\n}\n\n[data-theme='dark'] .adu-role { color: #cbd5e1; }\n[data-theme='dark'] .adu-role--customer { color: #93c5fd; background: rgba(59, 130, 246, 0.16); }\n[data-theme='dark'] .adu-role--provider { color: #6ee7b7; background: rgba(16, 185, 129, 0.16); }\n[data-theme='dark'] .adu-role--support,\n[data-theme='dark'] .adu-role--moderator { color: #fcd34d; background: rgba(251, 191, 36, 0.14); }\n[data-theme='dark'] .adu-role--admin,\n[data-theme='dark'] .adu-role--dev { color: #c4b5fd; background: rgba(167, 139, 250, 0.16); }\n\n.adu-user-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 14px;\n  font-size: 0.84rem;\n  color: var(--text-secondary);\n}\n\n.adu-user-meta span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n}\n\n.adu-user-email {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.adu-user-id {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n}\n\n.adu-user-id code {\n  font-family: var(--font-data);\n  font-size: 0.74rem;\n  color: var(--adu-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.adu-results-more {\n  margin: 14px 0 0;\n  text-align: center;\n  font-size: 0.82rem;\n  color: var(--adu-muted);\n}\n\n.adu-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 16px;\n  text-align: center;\n}\n\n.adu-empty-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  margin-bottom: 14px;\n  border-radius: 20px;\n  color: var(--adu-muted);\n  background: rgba(148, 163, 184, 0.12);\n}\n\n.adu-empty-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.adu-empty-text {\n  margin: 6px 0 0;\n  max-width: 380px;\n  font-size: 0.88rem;\n  color: var(--text-secondary);\n}\n\n/* ── Кнопки ── */\n.adu-btn {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 10px 18px;\n  border-radius: 12px;\n  font-size: 0.9rem;\n  font-weight: 700;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease,\n    box-shadow 0.18s ease, transform 0.18s ease, opacity 0.18s ease;\n}\n\n.adu-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.adu-btn:focus-visible {\n  outline: 2px solid var(--adu-danger);\n  outline-offset: 2px;\n}\n\n.adu-btn--danger-soft {\n  color: var(--adu-danger);\n  background: var(--adu-danger-soft);\n  border-color: var(--adu-danger-border);\n}\n\n.adu-btn--danger-soft:hover:not(:disabled) {\n  color: #fff;\n  background: var(--adu-danger-strong);\n  border-color: var(--adu-danger-strong);\n  box-shadow: 0 6px 16px rgba(220, 38, 38, 0.28);\n}\n\n.adu-btn--danger {\n  color: #fff;\n  background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);\n  box-shadow: 0 4px 14px rgba(220, 38, 38, 0.32);\n}\n\n.adu-btn--danger:hover:not(:disabled) {\n  background: linear-gradient(180deg, #dc2626 0%, #b91c1c 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 8px 20px rgba(220, 38, 38, 0.38);\n}\n\n.adu-btn--ghost {\n  color: var(--text-primary);\n  background: var(--bg-secondary, #f1f5f9);\n  border-color: var(--border-color);\n}\n\n.adu-btn--ghost:hover:not(:disabled) {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.adu-btn--ghost:focus-visible {\n  outline-color: var(--accent-primary);\n}\n\n.adu-spinner {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  animation: adu-spin 0.7s linear infinite;\n}\n\n.adu-spinner--accent {\n  flex-shrink: 0;\n  border-color: rgba(148, 163, 184, 0.35);\n  border-top-color: var(--accent-primary);\n}\n\n@keyframes adu-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── Модалка подтверждения ── */\n.adu-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n.adu-modal {\n  width: min(460px, 100%);\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  padding: 28px 26px 22px;\n  border-radius: 20px;\n  text-align: center;\n  background: var(--adu-surface-solid);\n  border: 1px solid var(--adu-line);\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.3);\n}\n\n[data-theme='dark'] .adu-modal {\n  border-color: var(--border-color);\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);\n}\n\n.adu-modal-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  margin-bottom: 14px;\n  border-radius: 50%;\n  color: var(--adu-danger);\n  background: var(--adu-danger-soft);\n  box-shadow: 0 0 0 8px rgba(220, 38, 38, 0.05);\n}\n\n.adu-modal-title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 800;\n  color: var(--text-primary);\n}\n\n.adu-modal-text {\n  margin: 8px 0 18px;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.adu-modal-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 14px;\n  text-align: left;\n  background: var(--bg-primary);\n  border: 1px solid var(--adu-line);\n}\n\n.adu-modal-user-texts {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.adu-modal-user-name {\n  font-weight: 700;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.adu-modal-user-meta {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n}\n\n.adu-modal-user-id {\n  font-family: var(--font-data);\n  font-size: 0.72rem;\n  color: var(--adu-muted);\n  word-break: break-all;\n}\n\n.adu-modal-consequences {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 16px 0;\n  padding: 0;\n  list-style: none;\n  text-align: left;\n}\n\n.adu-modal-consequences li {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 0.86rem;\n  color: var(--text-secondary);\n}\n\n.adu-modal-consequences svg {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: var(--adu-danger);\n}\n\n.adu-ack {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  text-align: left;\n  font-size: 0.86rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  cursor: pointer;\n  border: 1.5px dashed var(--adu-danger-border);\n  transition: background 0.18s ease, border-color 0.18s ease;\n}\n\n.adu-ack.is-checked {\n  border-style: solid;\n  border-color: var(--adu-danger);\n  background: var(--adu-danger-soft);\n}\n\n.adu-ack input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.adu-ack-box {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 6px;\n  color: transparent;\n  border: 1.5px solid var(--border-color);\n  background: var(--adu-surface-solid);\n  transition: all 0.15s ease;\n}\n\n.adu-ack.is-checked .adu-ack-box {\n  color: #fff;\n  border-color: var(--adu-danger);\n  background: var(--adu-danger);\n}\n\n.adu-ack input:focus-visible + .adu-ack-box {\n  outline: 2px solid var(--adu-danger);\n  outline-offset: 2px;\n}\n\n.adu-modal-error {\n  margin-top: 12px;\n  text-align: left;\n}\n\n.adu-modal-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n/* ── Адаптив ── */\n@media (max-width: 640px) {\n  .adu-hero {\n    padding: 20px 18px 16px;\n  }\n\n  .adu-warning {\n    margin: 0 18px;\n  }\n\n  .adu-toast {\n    margin: 14px 18px 0;\n  }\n\n  .adu-search,\n  .adu-body {\n    padding-left: 18px;\n    padding-right: 18px;\n  }\n\n  .adu-user {\n    flex-wrap: wrap;\n  }\n\n  .adu-user .adu-btn {\n    width: 100%;\n  }\n\n  .adu-modal {\n    padding: 22px 18px 18px;\n  }\n\n  .adu-modal-actions {\n    grid-template-columns: 1fr;\n  }\n\n  .adu-modal-actions .adu-btn--danger {\n    order: -1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
